import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { supersetReportsUrl } from "../../apis/postProvisionApi/postProvisionApi";
import "./Reports.css";

const Reports: React.FC = () => {
  const { clientId, clientName } = useParams<{
    clientId: string;
    clientName: string;
  }>();
  
const auth = useSelector((state: any) => state.authApiSlice);
const email = auth?.EmployeeEmail_Adr || "";
const fullName = auth?.EmployeeFull_Nm || "";
const employeeId = auth?.Id || "";
const nameParts = fullName.split(" ");
const firstName = nameParts[0] || "";
const lastName = nameParts.slice(1).join(" ");
const [loading, setLoading] = useState(true);
const [url, setUrl] = useState<string>("");
const token = sessionStorage.getItem("login");

  useEffect(() => {
    const fetchSupersetUrl = async (clientId:any, clientName:any) => {
      try {
        const response:any = await supersetReportsUrl(clientId, clientName);

        const Superset_Base_Url =`https://${response}/login?username=${email}&fname=${firstName}&lname=${lastName}&emp_id=${employeeId}&request_type=admin&token=${token}`;

        setUrl(Superset_Base_Url);
      } catch (error) {
        console.error("Failed to load Superset URL", error);
      }
    };

    fetchSupersetUrl(clientId, clientName);
  }, [clientId, clientName, token]);

  return (
    <div className="report-container">
      {loading && (
        <div className="loader-overlay">
          <div className="loader" />
        </div>
      )}

      {url && (
        <iframe
          src={url}
          title="Superset Reports"
          className="report-iframe"
          onLoad={() => setLoading(false)}
        />
      )}
    </div>
  );
};

export default Reports;
